module.exports = __webpack_public_path__ + "img/varvara-mobile.88247c75.jpg";